<template>
  <div>

    <div class="thing-list" v-if="array">
      <table-component
                       :column-width="columnWidth"
                       :legend="legend"
                       :clear-checked="clearMarker"
                       :columns="columns"
                       @changeCheckbox="checkedProjects = $event"
                       @filterName="filterName($event)"
                       @filterProject="filterProject($event)"
                       @filterOwner="filterOwner($event)"
                       ></table-component>

    </div>
  </div>
</template>

<script>
  import {tableComponentMixin} from "../../../../mixins/utils/tableComponentMixin";
  import {filters} from "../../../../mixins/filters";
  import {tokenAndRoute} from "../../../../mixins/utils/tokenAndRoute";
  import {mapState, mapGetters} from "vuex";

  import thingIcon from '../../../Svg/things/thingIcon'
  import virtualIcon from '../../../Svg/things/virtualIcon'

  export default {
    name: "thingOne",
    props: ['array'],
    mixins: [tableComponentMixin, filters, tokenAndRoute],
    components: {thingIcon, virtualIcon},
    data() {
      return {
        linkToAvatarExample: 'dist/assets/logo.png',

        //table
        legend: [
          {
            text: 'Название вещи',
            filterMethod: 'filterName',
            legendSort: true,
            legendDown: true,
            legendUp: true,
            activeFilter: false
          },

          {
            text: 'Владелец',
            filterMethod: 'filterOwner',
            legendSort: true,
            legendDown: true,
            legendUp: true,
            activeFilter: false
          },
          {
            text: 'Тип',
            legendSort: false,
            isGear: false
          },
          {
            text: '',
            legendSort: false,
            isGear: true
          }
        ],
        columnWidth: [570/1140 * 100, 395/1140 * 100, 200/1140 * 100, 0],
        clearMarker: false,
      }
    },
    computed: {
      ...mapState({
        projects: state => state.projects.allProjects
      }),
      ...mapGetters({
        projectOwner: 'projects/projectOwnerRole'
      }),
      projectId() {
        if (this.routeItem) {
          return Number(this.routeItem)
        } else {
          return Number(this.routeId)
        }
      },
      projectOwnerRoleId() {
        let project = this.projects.find(project => project.id === this.projectId)
        return project.owner_role_id
      },
      columns() {
        return this.array.map(item => {

          return {
            // id: item.id,
            dblClick: item.id,
            dblClickPrefix: '/things/thing/',
            cells: [
              {
                text: {
                  isLink: false,
                  text: item.name,
                  addTextData: {}
                },
                avatar: {
                  isAvatar: true,
                },
                type: item.type

              },
              {
                text: {
                  isLink: false,
                  text: `${this.ownerRole(this.projectOwnerRoleId).user.first_name} ${this.ownerRole(this.projectOwnerRoleId).user.second_name ? this.ownerRole(this.projectOwnerRoleId).user.second_name : ''}`,
                  addTextData: {}
                },
                avatar: {
                  isAvatar: true,
                  // avatarLink: this.linkToAvatarExample
                }
              },
              {
                text: {
                  isLink: false,
                  text: `${!item.virtual ? 'Вещь' : 'Мультивещь'}`,
                  addTextData: {}
                },
                avatar: {
                  isAvatar: false,
                }
              },
              {
                isGear: true,
                text: {
                  isLink: false,
                  addTextData: {}
                },
                avatar: {
                  isAvatar: false,
                }
              },
            ]
          }
        })
      }
    },
    methods: {
      ownerRole(id) {
        return this.projectOwner(id)
      },

    },
  }
</script>

<style lang="scss" scoped>
  .thing-list {
    padding: 20px 0 0; //поправить потом
  }
</style>
